module.exports = __webpack_public_path__ + "media/images/smart_phone/rank/icon_rank4-0b6d15d3820045a14bf8ca3c29fc5002.png";